import { Button, Col, Flex, notification, Radio, Row, Typography } from "antd";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";

const { Text } = Typography;

const ClaimType = ({ setModalTypeOpen }) => {
	const [type, setType] = useState(null);
	const [apiNotification, contextHolder] = notification.useNotification();
	const history = useHistory();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	const onChangeType = (e) => {
		setType(e.target.value);
	};

	const handleNext = () => {
		if (!type) {
			openNotification(
				"warning",
				"Warning",
				"Please select a claim type before proceeding."
			);
		} else {
			history.push({
				pathname: "/claim/new",
				state: {
					type: type,
				},
			});
		}
	};

	return (
		<div>
			<Row gutter={[16, 16]}>
				<Col span={24}>
					<Radio.Group
						style={{
							display: "flex",
							flexDirection: "column",
							gap: 8,
						}}
						onChange={onChangeType}
						value={type}
						options={[
							{
								value: "Product Quality Issue",
								label: "Product Quality Issue",
							},
							{ value: "Delay in Delivery", label: "Delay in Delivery" },
							{ value: "Wrong Order Sent", label: "Wrong Order Sent" },
							{
								value: "Overcharge/Billing Error",
								label: "Overcharge/Billing Error",
							},
							{ value: "Site Safety Issue", label: "Site Safety Issue" },
						]}
					/>
				</Col>
				<Col span={24}>
					<Text strong>
						If your claim does not fall under any of the listed options, please
						contact your supervisor for further guidance.
					</Text>
				</Col>
			</Row>
			&nbsp;
			<Flex justify="space-between">
				<Button size="large" onClick={() => setModalTypeOpen(false)}>
					Cancel
				</Button>
				<Button size="large" type="primary" onClick={handleNext}>
					Next
				</Button>
			</Flex>
			{contextHolder}
		</div>
	);
};

export default ClaimType;
